import React from "react";
import "./Counter.css";

const Counter = () => {
  return (
    <section className="Counter section_margin">
      <div className="container">
        <div className="content_div">
          <div className="row">
            <div className="col-md-6 p-1">
              <div className="box orange_div box1">
                <div className="text_holder">
                  <p className="count_text">95%</p>
                  <p className="label_text">First-Time Pass</p>
                </div>
              </div>
            </div>
            <div className="col-md-6 p-1">
              <div className="box blue_div box1">
                <div className="text_holder">
                  <p className="count_text">1000+</p>
                  <p className="label_text">Happy Learners</p>
                </div>
              </div>
            </div>
            <div className="col-md-6 p-1">
              <div className="box blue_div box2">
                <div className="text_holder">
                  <p className="count_text">20+ </p>
                  <p className="label_text">Professional Trainers</p>
                </div>
              </div>
            </div>
            <div className="col-md-6 p-1">
              <div className="box orange_div box2">
                <div className="text_holder">
                  <p className="count_text">10+ </p>
                  <p className="label_text">Years of Expertise</p>
                </div>
              </div>
            </div>
          </div>

          <div className="circle_div">
            <img
              src="/assets/images/home/counter/circle.png"
              className="circle_img"
            />
          </div>

          <div className="inner_circle_img">
            <img
              src="/assets/images/home/counter/inner_img.png"
              className="inner_img"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Counter;
